
import { PageMeta } from '../../components/shared/PageMeta';
import { Navigation } from '../../components/feature/Navigation';
import { AboutHeroSection } from './components/AboutHeroSection';
import { MissionSection } from './components/MissionSection';
import { TimelineSection } from './components/TimelineSection';
import { ValuesSection } from './components/ValuesSection';
import { FooterSection } from '../../components/feature/FooterSection';
import { MinimalAurora } from '../../components/feature/MinimalAurora';

export default function AboutPage() {
  return (
    <div className="min-h-screen relative bg-black">
      <PageMeta path="/about" />
      {/* Minimal Aurora Background */}
      <MinimalAurora />
      
      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <AboutHeroSection />
        <MissionSection />
        <TimelineSection />
        <ValuesSection />
        <FooterSection />
      </div>
    </div>
  );
}
